import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import {
  getFetchNextBookingStatus,
  getFetchCustomerCreditStatus
} from 'store/apiStatus';
import { getActiveCustomer } from 'store/auth';
import { fetchNextBookingRequest, getNextBooking } from 'store/bookings';
import {
  fetchCustomerCreditRequest,
  getCustomerCredit
} from 'store/customerCredit';
import { getReferralCoupon } from 'store/referralCoupon';

import { Content, Spinner } from 'components/Common';
import { Header, NextBooking, Credits, ReferralCode } from 'components';

export class Overview extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    customer: PropTypes.object.isRequired,
    referralCoupon: PropTypes.object,
    nextBookingStatus: PropTypes.object.isRequired,
    nextBooking: PropTypes.object,
    customerCreditStatus: PropTypes.object.isRequired,
    customerCredit: PropTypes.object,
    onFetchNextBooking: PropTypes.func.isRequired,
    onFetchCustomerCredit: PropTypes.func.isRequired
  };

  static defaultProps = {
    nextBooking: null,
    customerCredit: null,
    referralCoupon: null
  };

  componentDidMount() {
    this.props.onFetchNextBooking();
    this.props.onFetchCustomerCredit();
  }

  isReady() {
    return (
      this.props.nextBookingStatus.isRequested &&
      this.props.customerCreditStatus.isRequested &&
      !this.props.nextBookingStatus.isLoading &&
      !this.props.customerCreditStatus.isLoading
    );
  }

  render() {
    return (
      <div>
        <Header
          title={this.props.t('overview.title', {
            name: this.props.customer.primaryPerson.firstname
          })}
          description={this.props.t('overview.description')}
        />

        <Content>
          {this.isReady() ? (
            <div className="row">
              <main className="column small-12 large-8">
                <NextBooking
                  booking={this.props.nextBooking}
                  status={this.props.nextBookingStatus}
                />
              </main>

              <aside className="column small-12 large-4 aside">
                {this.props.customerCredit && (
                  <Credits customerCredit={this.props.customerCredit} />
                )}

                {this.props.referralCoupon && (
                  <ReferralCode referralCoupon={this.props.referralCoupon} />
                )}
              </aside>
            </div>
          ) : (
            <Spinner />
          )}
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  customer: getActiveCustomer(state),
  referralCoupon: getReferralCoupon(state),
  nextBookingStatus: getFetchNextBookingStatus(state),
  nextBooking: getNextBooking(state),
  customerCreditStatus: getFetchCustomerCreditStatus(state),
  customerCredit: getCustomerCredit(state)
});

const mapDispatchToProps = {
  onFetchNextBooking: fetchNextBookingRequest,
  onFetchCustomerCredit: fetchCustomerCreditRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(Overview)
);



// WEBPACK FOOTER //
// ./src/containers/Overview/Overview.js